/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AbsenceEventSubscription } from '../model/absenceEventSubscription';
import { EndUserEventSubscription } from '../model/endUserEventSubscription';
import { EventsResponse } from '../model/eventsResponse';
import { SubscribeResponse } from '../model/subscribeResponse';
import { UnsubscribeResponse } from '../model/unsubscribeResponse';
import { VirtualNumberEventSubscription } from '../model/virtualNumberEventSubscription';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { PushSubscriptionServiceInterface }                            from './pushSubscription.serviceInterface';


@Injectable()
export class PushSubscriptionService implements PushSubscriptionServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEvents1(observe?: 'body', reportProgress?: boolean): Observable<EventsResponse>;
    public getEvents1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventsResponse>>;
    public getEvents1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventsResponse>>;
    public getEvents1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.get<EventsResponse>(`${this.basePath}/push/events`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscribeAbsence1(body?: Array<AbsenceEventSubscription>, observe?: 'body', reportProgress?: boolean): Observable<SubscribeResponse>;
    public subscribeAbsence1(body?: Array<AbsenceEventSubscription>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscribeResponse>>;
    public subscribeAbsence1(body?: Array<AbsenceEventSubscription>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscribeResponse>>;
    public subscribeAbsence1(body?: Array<AbsenceEventSubscription>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SubscribeResponse>(`${this.basePath}/push/absence`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscribeEndUser1(body?: Array<EndUserEventSubscription>, observe?: 'body', reportProgress?: boolean): Observable<SubscribeResponse>;
    public subscribeEndUser1(body?: Array<EndUserEventSubscription>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscribeResponse>>;
    public subscribeEndUser1(body?: Array<EndUserEventSubscription>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscribeResponse>>;
    public subscribeEndUser1(body?: Array<EndUserEventSubscription>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SubscribeResponse>(`${this.basePath}/push/eu`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscribeVirtualNumber1(body?: Array<VirtualNumberEventSubscription>, observe?: 'body', reportProgress?: boolean): Observable<SubscribeResponse>;
    public subscribeVirtualNumber1(body?: Array<VirtualNumberEventSubscription>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscribeResponse>>;
    public subscribeVirtualNumber1(body?: Array<VirtualNumberEventSubscription>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscribeResponse>>;
    public subscribeVirtualNumber1(body?: Array<VirtualNumberEventSubscription>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SubscribeResponse>(`${this.basePath}/push/vn`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unsubscribe1(observe?: 'body', reportProgress?: boolean): Observable<UnsubscribeResponse>;
    public unsubscribe1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UnsubscribeResponse>>;
    public unsubscribe1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UnsubscribeResponse>>;
    public unsubscribe1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<UnsubscribeResponse>(`${this.basePath}/push/unsubscribe`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
